export interface ProjectType {
  id: number;
  title: string;
  location: string;
  image: string;
  category: string;
}

export const projects: ProjectType[] = [
  {
    id: 1,
    title: "Шпакловка и боядисване на апартамент",
    location: "гр. София, кв. Лозенец",
    image: "/bojadisvane.jpg",
    category: "apartments"
  },
  {
    id: 2,
    title: "Изграждане на луксозна баня",
    location: "гр. София, кв. Изток",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    category: "bathrooms"
  },
  {
    id: 3,
    title: "Монтаж на кухненски плот и фаянс",
    location: "гр. София, кв. Манастирски ливади",
    image: "/kuhenski-plot.webp",
    category: "kitchens"
  },
  {
    id: 4,
    title: "Довършителни работи в дневна",
    location: "гр. София, кв. Младост",
    image: "/dnevna.jpg",
    category: "apartments"
  },
  {
    id: 5,
    title: "Стенна декорация с гипсова мазилка",
    location: "гр. София, кв. Драгалевци",
    image: "/dekoracia-gips.avif",
    category: "decorative"
  },
  {
    id: 6,
    title: "Минималистична баня с плочки",
    location: "гр. София, кв. Студентски град",
    image: "/minimalisticna-banja.png",
    category: "bathrooms"
  },
  {
    id: 7,
    title: "Монтаж на гранитогрес в кухня",
    location: "гр. София, кв. Витоша",
    image: "https://images.unsplash.com/photo-1588854337236-6889d631faa8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    category: "kitchens"
  },
  {
    id: 8,
    title: "Окачен таван с вградено осветление",
    location: "гр. София, кв. Бояна",
    image: "/tavan-s-osvetlenie.jpg",
    category: "apartments"
  },
  {
    id: 9,
    title: "Цялостна реновация на хол",
    location: "гр. София, кв. Симеоново",
    image: "/kompletna-renovacija-hol.jpg",
    category: "apartments"
  }
];
